module.exports = __webpack_public_path__ + "img/empresas-img.014e6e0b.svg";